import { Button } from '@southfields-digital/mpxlive-components';
import classNames from 'classnames';
import type { ComponentProps } from 'react';

type AdjustButtonProps = ComponentProps<typeof Button> & {
  isSquare?: boolean;
  icon?: string;
  className?: string;
};

const AdjustButton = ({ icon, className, isSquare = false, ...props }: AdjustButtonProps) => (
  <Button
    color="darkGray"
    className={classNames(
      'h-9 w-10 !font-semibold !rounded justify-items-center !overflow-visible',
      isSquare && 'aspect-square w-fit',
      className
    )}
    iconProps={icon ? { icon: icon, weight: 'bold', size: 20 } : undefined}
    {...props}
  />
);

export default AdjustButton;
